<template>
  <div>
    <form v-on:submit.prevent id="quote-form">
      <h2 v-if="isContact" class="contact-form">Contact Form</h2>
      <h3 v-else>Request A Quote</h3>
      <div class="contact-us">
        <label for="first-name"> First Name:
          <input placeholder="First Name" class="user-info-input" type="text" data-field="first-name"
                 v-model="firstName" id="first-name" required>
        </label>
        <label for="last-name"> Last Name:
          <input placeholder="Last Name" class="user-info-input" type="text" data-field="last-name" v-model="lastName"
                 id="last-name" required>
        </label>
        <label for="email"> Email:
          <input placeholder="Email" class="user-info-input" type="text" data-field="email" v-model="email" id="email"
                 required>
        </label>
        <label for="phone"> Phone:
          <input placeholder="Phone" class="user-info-input" type="text" data-field="phone" v-model="phone" id="phone"
                 required>
        </label>
        <label v-if="!isContact" for="product"> Product of Interest:
          <input placeholder="Product of Interest" class="user-info-input" type="text" data-field="product"
                 v-model="product" id="product">
        </label>
        <label for="description"> Description:
          <textarea rows="5" class="user-info-input" data-field="description" v-model="description" id="description"
                    placeholder="Description"></textarea>
        </label>
      </div>
      <div class="user-actions">
        <button class="button action-button" v-on:click="clearForm()">Clear Form</button>
        <button v-if="isContact" class="quote-button primary button action-button" v-on:click="handleFormSubmit()">Submit</button>
        <button v-else class="quote-button primary button action-button" v-on:click="handleFormSubmit()">Get Quote</button>
      </div>
    </form>

    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>

</template>

<script>
import Vue from 'vue'
import Modal from '@/widgets/Modal'

import services from '../common/services/service-directory.js'
import serviceManager from '../common/services/service-manager.js'

Vue.component('modal')

Object.defineProperty(Vue.prototype, '$services', {value: services})
Object.defineProperty(Vue.prototype, '$serviceManager', {value: serviceManager})

export default {
  name: 'GetQuoteForm',
  props: ['isContact'],
  data: function () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      product: '',
      description: '',
      showModal: false,
      modalHeader: '',
      modalBody: ''
    }
  },
  methods: {
    clearForm: function () {
      let fields = document.querySelectorAll('.user-info-input')

      for (let i = 0; i < fields.length; i++) {
        fields[i].value = ''
      }
    },
    handleFormSubmit: function () {
      let self = this
      let options = {
        headers: {},
        data: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          telephone: this.phone,
          product: this.product,
          additionalDetails: this.description
        },
        url: this.$services.quote.url
      }
      let form = document.getElementById('quote-form')

      if (form.checkValidity()) {
        this.$serviceManager.post(options).then(function (response) {
          (response.success) ? self.handleSubmitSuccess(response) : self.handleSubmitFailure(response)
        }).catch(self.handleSubmitFailure.bind(self))
      }
    },
    handleSubmitSuccess: function (response) {
      this.modalHeader = 'Success'
      this.modalBody = response.msg

      this.showModal = true
    },
    handleSubmitFailure: function (response) {
      this.modalHeader = 'Error'
      this.modalBody = response.msg || 'We were unable to complete your request. Please try again later.'

      this.showModal = true
    }
  },
  components: {
    Modal
  }
}
</script>

<style scoped>
.user-info-input:focus::placeholder {
  color: transparent;
}

.contact-form {
  text-align: center;
}

@media screen and (max-width: 1280px) {
  .action-button {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GetQuoteForm.vue